$(document).ready(function() {
  // GLOBAL Grid JAVASCRIPT

  // Insert white divat top of grey color background making the top 30% of the wrap white, leaving the bottom 70% grey.
  $('.light-grey.tall-75').prepend('<div class="white-25"></div>');
  $('.light-grey.tall-65').prepend('<div class="white-35"></div>');
});